import Typography from "@mui/material/Typography";
import { Fade } from "@mui/material";
import { PageHeader } from "../../components";
import * as s from "./styles";

const PrivacyPolicy = () => {
  return (
    <Fade in timeout={1000}>
      <s.PageContainer>
        <PageHeader
          label={"Política de privacidade"}
          handleBackPress={() => {}}
        />
        <s.PageContent>
          <div style={{ display: "grid", gap: "1rem" }}>
            <Typography variant="h4">
              Política de Privacidade - Aplicativo Rede Arena
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Data de vigência: 17/12/2023
            </Typography>

            <Typography variant="body1" sx={{ color: "gray" }}>
              Saudações e boas-vindas ao Aplicativo Rede Arena! Esta Política de
              Privacidade tem como propósito esclarecer como coletamos,
              utilizamos, compartilhamos e protegemos suas informações pessoais
              durante o uso do Aplicativo Rede Arena.
            </Typography>

            {/* Seção 1: Informações Coletadas */}
            <Typography variant="h5">1. Informações Coletadas</Typography>

            <Typography variant="body1" sx={{ color: "gray" }}>
              <Typography variant="subtitle1">1.1. Dados Pessoais:</Typography>
              Coletamos informações cruciais, como nome, CPF, telefone, plano
              escolhido, valor do plano e vencimento do mesmo, com o intuito de
              fornecer nossos serviços. Outras informações são originadas das
              unidades da Rede Arena.
            </Typography>

            <Typography variant="body1" sx={{ color: "gray" }}>
              <Typography variant="subtitle1">
                1.2. Informações Automáticas:
              </Typography>
              Automaticamente registramos o tipo de dispositivo (Android ou iOS)
              utilizado para aprimorar a experiência do usuário.
            </Typography>

            {/* Seção 2: Utilização de Suas Informações */}
            <Typography variant="h5">
              2. Utilização de Suas Informações
            </Typography>

            <Typography variant="body1" sx={{ color: "gray" }}>
              <Typography variant="subtitle1">
                2.1. Prestação de Serviços:
              </Typography>
              Utilizamos suas informações para otimizar nossos serviços e
              garantir a entrega do plano escolhido.
            </Typography>

            <Typography variant="body1" sx={{ color: "gray" }}>
              <Typography variant="subtitle1">2.2. Comunicações:</Typography>
              Podemos enviar notificações no aplicativo referentes a ofertas,
              promoções e oportunidades exclusivas relacionadas ao Aplicativo
              Rede Arena.
            </Typography>

            {/* Seção 3: Compartilhamento de Informações */}
            <Typography variant="h5">
              3. Compartilhamento de Informações
            </Typography>

            <Typography variant="body1" sx={{ color: "gray" }}>
              <Typography variant="subtitle1">3.1. Acesso Restrito:</Typography>
              O acesso às suas informações é restrito ao gerente da Rede Arena e
              a você mesmo.
            </Typography>

            <Typography variant="body1" sx={{ color: "gray" }}>
              <Typography variant="subtitle1">
                3.2. Armazenamento Seguro:
              </Typography>
              Suas informações são armazenadas no Google Cloud, seguindo
              rigorosos padrões de segurança e disponibilidade.
            </Typography>

            <Typography variant="body1" sx={{ color: "gray" }}>
              <Typography variant="subtitle1">
                3.3. Sistema de Autenticação:
              </Typography>
              Implementamos um sistema de autenticação para garantir que somente
              usuários devidamente autenticados e autorizados possam acessar
              seus dados.
            </Typography>

            {/* Seção 4: Segurança das Informações */}
            <Typography variant="h5">4. Segurança das Informações</Typography>

            <Typography variant="body1" sx={{ color: "gray" }}>
              <Typography variant="subtitle1">
                4.1. Solicitações de Alteração:
              </Typography>
              Você pode solicitar alterações em suas informações diretamente na
              unidade da Rede Arena onde realizou seu cadastro.
            </Typography>

            {/* Seção 5: Seus Direitos e Escolhas */}
            <Typography variant="h5">5. Seus Direitos e Escolhas</Typography>

            <Typography variant="body1" sx={{ color: "gray" }}>
              <Typography variant="subtitle1">
                5.1. Comunicações de Marketing:
              </Typography>
              Reiteramos que não encaminhamos comunicações de marketing fora do
              ambiente do aplicativo.
            </Typography>

            {/* Seção 6: Alterações nesta Política */}
            <Typography variant="h5">6. Alterações nesta Política</Typography>

            <Typography variant="body1" sx={{ color: "gray" }}>
              <Typography variant="subtitle1">6.1. Avisos:</Typography>
              Alterações nesta política serão prontamente comunicadas no
              aplicativo, especificamente na seção "Política de Privacidade".
            </Typography>

            {/* Seção 7: Contato */}
            <Typography variant="h5">7. Contato</Typography>

            <Typography variant="body1" sx={{ color: "gray" }}>
              <Typography variant="subtitle1">7.1. Dúvidas:</Typography>
              Caso possua alguma dúvida sobre esta política, ficamos à
              disposição por meio do e-mail uesleisuptitz@gmail.com.
            </Typography>
          </div>
        </s.PageContent>
      </s.PageContainer>
    </Fade>
  );
};

export default PrivacyPolicy;
